export default __webpack_public_path__ + "static/media/php-logo.f39f7879.png";